import React from "react";
import styles from "./ContinueWatching.module.css";
import VideoCard from "../VideoCard/VideoCard";

export default function ContinueWatching({ items, likes, onPlay, onToggleLike, getPct }){
  if(!items.length){
    return <div className="empty">Nothing here yet — start any video below and it will appear here.</div>;
  }
  return (
    <>
      {items.map(v => (
        <VideoCard
          key={v.id}
          item={v}
          liked={!!likes[v.id]}
          onPlay={onPlay}
          onToggleLike={onToggleLike}
          progressPct={getPct(v.id)}
        />
      ))}
    </>
  );
}